<template>
  <v-container fluid>
    <v-toolbar color="white" flat>
      <v-toolbar-title>Concursos</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" dark @click="incluirConcurso()">Incluir</v-btn>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="concursos"
      :items-per-page="10"
      :loading="fetchConcursosLoading"
      :no-data-text="
        fetchConcursosLoading ? 'Carregando' : 'Nenhum Registro para mostrar'
      "
      class="elevation-1"
    >
      <template v-slot:[`item.dataInicial`]="{ item }">
        <span>{{ formatDate(item.dataInicial) }}</span>
      </template>
      <template v-slot:[`item.dataFinal`]="{ item }">
        <span>{{ formatDate(item.dataFinal) }}</span>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <span>{{
          item.status == "aberto"
            ? "Aberto"
            : item.status == "encerrado"
            ? "Encerrado"
            : "Previsto"
        }}</span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <span style="margin-right: 10px;">
          <v-icon small @click="editItem(item)">edit</v-icon></span
        >
        <span> <v-icon small @click="deleteItem(item)">delete</v-icon></span>
      </template>
      <template v-slot:[`item.winner`]="{ item }">
        <span> <v-icon small @click="showWinner(item)">emoji_events</v-icon></span>
      </template>
    </v-data-table>
    <v-dialog v-model="winnerDialog" persistent max-width="900">
      <v-card>
        <v-card-title>
          Ganhadores do concurso: {{concursoSelecionado.numero}}
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersGanhadores"
            :items="ganhadores"
            :items-per-page="10"
            :loading="fetchGanhadoresLoading"
            :no-data-text="
              fetchGanhadoresLoading ? 'Carregando' : 'Nenhum Registro para mostrar'
            "
            class="elevation-1"
          ></v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            ma-2
            text
            small
            color="primary"
            @click="winnerDialog = false"
          >Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <app-delete-dialog
      msg="Deseja Remover o concurso selecionado?"
      :dialogDelete="deleteDialog"
      :id="selectedId"
      @onConfirmDelete="onConfirmDelete($event)"
      @onCancelDelete="deleteDialog = false"
    ></app-delete-dialog>
    <concurso-dialog v-model="dialog" :values="concurso"></concurso-dialog>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import util from "@/service/util-service";
import DeleteDialog from "@/views/delete/DeleteDialog";
import ConcursoDialog from "@/views/concursolj/ConcursoLjDialog";

export default {
  components: {
    "app-delete-dialog": DeleteDialog,
    "concurso-dialog": ConcursoDialog,
  },

  data() {
    return {
      headers: [
        { text: "", value: "actions", sortable: false },
        { text: "Ganhador", value: "winner", sortable: false },
        {
          text: "Numero",
          align: "left",
          sortable: true,
          value: "numero",
        },
        {
          text: "Valor",
          align: "left",
          sortable: true,
          value: "valor",
        },
        {
          text: "Data Inicial",
          align: "left",
          sortable: true,
          value: "dataInicial",
        },
        {
          text: "Data Final",
          align: "left",
          sortable: true,
          value: "dataFinal",
        },
        {
          text: "Total de números",
          align: "left",
          sortable: true,
          value: "totalnumeros",
        },
        {
          text: "Números",
          align: "left",
          sortable: true,
          value: "numeros",
        },
        {
          text: "Status",
          align: "left",
          sortable: true,
          value: "status",
        },
      ],
      headersGanhadores: [
        {
          text: "Nome",
          align: "left",
          sortable: true,
          value: "nome",
        },
        {
          text: "Qtde Apostas",
          align: "left",
          sortable: true,
          value: "apostas",
        },
        {
          text: "Premio",
          align: "left",
          sortable: true,
          value: "premio",
        },
        {
          text: "Email",
          align: "left",
          sortable: true,
          value: "email",
        },
        {
          text: "Telefone",
          align: "left",
          sortable: true,
          value: "telefone",
        },
      ],
      updateLoading: false,
      fetchConcursosLoading: false,
      deleteDialog: false,
      winnerDialog: false,
      concursoSelecionado: {},
      fetchGanhadoresLoading: false,
      selectedId: 0,
      dialog: false,
      concurso: null,
    };
  },
  computed: {
    ...mapGetters({
      concursos: "concursos",
      ganhadores: "ganhadores",
    }),
  },

  watch: {
    dialog(v) {
      if (!v) {
        this.loadConcursos();
      }
    },
  },
  created() {
    this.loadConcursos();
  },

  methods: {
    loadConcursos() {
      this.fetchConcursosLoading = true;
      this.$store
        .dispatch("fetchConcursos")
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.fetchConcursosLoading = false;
        });
    },
    loadGanhadores() {
      this.fetchGanhadoresLoading = true;
      this.$store
        .dispatch("fetchGanhadoresConcursos", this.concursoSelecionado.id)
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.fetchGanhadoresLoading = false;
        });
    },
    incluirConcurso() {
      // this.resetForm();
      this.concurso = {};
      // this.concurso.dataInicial = new Date().toISOString().substr(0, 10);
      // this.dtkey = +1;
      // this.isInsert = true;
      this.dialog = true;
    },
    editItem(item) {
      // this.resetForm();
      // this.isInsert = false;
      this.concurso = { ...item };
      // this.concurso.dataInicial = new Date().toISOString().substr(0, 10);
      // this.dtkey = +1;
      this.dialog = true;
    },
    showWinner( item ) {
      this.concursoSelecionado = { ...item }
      this.loadGanhadores()
      this.winnerDialog = true;
    },
    deleteItem(item) {
      this.selectedId = item.id;
      this.deleteDialog = true;
    },
    onConfirmDelete(event) {
      this.deleteDialog = false;
      this.$store
        .dispatch("removeConcursoLj", event)
        .then((value) => {
          console.log(value);
          if (value.type == "error") {
            this.$store.dispatch("setNotification", {
              type: "error",
              text: value.msg,
            });
          } else {
            this.$store.dispatch("setNotification", {
              type: "success",
              text: value.msg,
            });
            this.loadConcursos();
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.updateLoading = false;
        });
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("T")[0].split("-");
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
